<template>
  <div style="height:100%;width:100%">
    <div id="myearth">
      <div id="atmos"></div>
    </div>
    <div id="res">
      <img id="day" src="../assets/images/miniature-earth/day-by-nasa.jpg" />
      <img
        id="night"
        src="../assets/images/miniature-earth/night-by-nasa.jpg"
      />
    </div>

    <div
      class="ggcfooter"
      style="zorder: 150; position: absolute !important;; bottom: 10px"
    >
      <h2>{{ challengeSelectionText }}</h2>
    </div>
  </div>
</template>

<script>
import { gameAssetsMixin } from '../mixins/gameAssetsMixin'

export default {
  mixins: [gameAssetsMixin],
  components: {},
  data: () => ({
    selectedChallengeIndex: null,
    earth: Object,
    hotspots: [],
    currentActiveHotspotIndex: null,
    sunAngle: 90,
    lightMask: null,
    lightMaskCtx: null,
    lightGradient: null
  }),
  props: {
    gameID: { type: String, required: true },
    gameboard: { type: String, required: false },
    challenges: { type: Array, required: true },
    challengeSelectionText: { type: String, required: true }
  },
  created() {},
  mounted() {
    this.loadExternalJavascript()
  },
  methods: {
    loadExternalJavascript() {
      let scriptURL = this.resolveGeneralAssetURL(
        'external/miniature-earth/miniature.earth.core.js'
      )

      let scriptTag = document.head.querySelector(`[src="${scriptURL}"`)
      if (scriptTag) {
        this.externalScriptLoaded()
      } else {
        scriptTag = document.createElement('script')

        let self = this
        scriptTag.onload = () => {
          self.externalScriptLoaded()
        }

        scriptTag.setAttribute('src', scriptURL)
        scriptTag.setAttribute('type', 'text/javascript')
        document.head.appendChild(scriptTag)
      }
    },
    externalScriptLoaded() {
      this.loadGlobe()
    },
    loadGlobe() {
      // eslint-disable-next-line no-undef
      this.earth = new Earth('myearth', {
        location: { lat: 10, lng: -74 },
        sunLocation: { lat: 0, lng: 360 - this.sunAngle },
        zoom: 0.925,

        dragPolarLimit: 0,

        light: 'sun',
        shadows: true,
        lightAmbience: 0.9,
        shininess: 0.44,

        autoRotate: true,
        autoRotateSpeed: 1,
        autoRotateDelay: 2000,
        autoRotateStart: 2000
      })

      let self = this
      this.earth.addEventListener('ready', function() {
        self.earthIsReady()
      })
    },
    earthIsReady() {
      console.log(`🌎🌎🌎 Ready is earth!`)

      this.earth.startAutoRotate()

      this.addBackgroundStarfield()

      this.challenges.forEach(challenge => {
        console.log(
          `challenge: ${challenge.title}, lat: ${challenge.latitude}, lon: ${challenge.longitude}`
        )

        this.addHotspot(
          challenge.title,
          challenge.latitude,
          challenge.longitude
        )
      })

      this.prepareLightMask()
      this.updateMapTexture()

      // Quick and dirty hack to try to be sure the map texture is loaded
      setTimeout(() => {
        this.updateMapTexture()
      }, 1000)

      setTimeout(() => {
        this.updateMapTexture()
      }, 5000)
    },
    addHotspot(title, latitude, longitude) {
      let openOverlay = this.earth.addOverlay({
        location: { lat: latitude, lng: longitude },
        offset: 1.5,
        content: `<span style="color:#ffffff"><h2>${title}</h2><h5 class="earthHotspotButton">PLAY</h5></span>`,
        depthScale: 0.4,
        visible: false,
        className: 'earthHotspotLabel'
      })

      let loadingOverlay = this.earth.addOverlay({
        location: { lat: latitude, lng: longitude },
        offset: 1.5,
        content: `<span style="color:#ffffff"><h2>${title}</h2><h5 class="earthHotspotButton"><span class="button-loading-spinner"></span></h5></span>`,
        depthScale: 0.4,
        visible: false,
        className: 'earthHotspotLabel'
      })

      let closedOverlay = this.earth.addOverlay({
        location: { lat: latitude, lng: longitude },
        depthScale: 0.4,
        className: 'earthHotspot'
      })

      let index =
        this.hotspots.push({
          closedOverlay: closedOverlay,
          openOverlay: openOverlay,
          loadingOverlay: loadingOverlay
        }) - 1

      let self = this
      openOverlay.element.addEventListener('click', function() {
        self.earthHotspotClicked(index)
      })
      closedOverlay.element.addEventListener('click', function() {
        self.earthHotspotClicked(index)
      })
    },
    earthHotspotClicked(index) {
      console.log(`Hotspot was clicked: ${index}`)

      if (this.currentActiveHotspotIndex === index) {
        let currentActiveHotspot = this.hotspots[this.currentActiveHotspotIndex]

        this.updateHotspotState(currentActiveHotspot, 'loading')

        this.chooseChallenge(index)

        setTimeout(() => {
          if (this.currentActiveHotspotIndex === index) {
            this.updateHotspotState(currentActiveHotspot, 'open')
          }
        }, 5000)

        return
      }

      if (this.currentActiveHotspotIndex !== null) {
        this.updateHotspotState(
          this.hotspots[this.currentActiveHotspotIndex],
          'closed'
        )
      }

      this.updateHotspotState(this.hotspots[index], 'open')

      this.currentActiveHotspotIndex = index
    },
    updateHotspotState(hotspot, state) {
      switch (state) {
        case 'open':
          hotspot.openOverlay.visible = true
          hotspot.closedOverlay.visible = false
          hotspot.loadingOverlay.visible = false
          break
        case 'loading':
          hotspot.openOverlay.visible = false
          hotspot.closedOverlay.visible = false
          hotspot.loadingOverlay.visible = true
          break
        case 'closed':
          hotspot.openOverlay.visible = false
          hotspot.closedOverlay.visible = true
          hotspot.loadingOverlay.visible = false
          break
      }
    },
    prepareLightMask() {
      this.lightMask = document.createElement('canvas')
      this.lightMaskCtx = this.lightMask.getContext('2d')

      var w = this.earth.mapCanvas.width,
        h = this.earth.mapCanvas.height

      this.lightMask.width = w * 2
      this.lightMask.height = h

      this.lightGradient = this.lightMaskCtx.createRadialGradient(
        w / 2,
        h / 2,
        h * 0.38,
        w / 2,
        h / 2,
        w * 0.28
      )

      this.lightGradient.addColorStop(0, 'RGBA(0,0,0,1)')
      this.lightGradient.addColorStop(1, 'RGBA(0,0,0,0)')
    },

    updateMapTexture() {
      var w = this.earth.mapCanvas.width,
        h = this.earth.mapCanvas.height

      // night background
      var nightImg = document.getElementById('day')
      this.earth.mapContext.drawImage(
        nightImg,
        0,
        0,
        nightImg.width,
        nightImg.height,
        0,
        0,
        w,
        h
      )

      var offset = (this.sunAngle / 360) * w

      this.lightMaskCtx.clearRect(0, 0, w * 2, h)
      this.lightMaskCtx.globalCompositeOperation = 'source-over'
      this.lightMaskCtx.fillStyle = this.lightGradient
      this.lightMaskCtx.fillRect(0, 0, w, h)
      this.lightMaskCtx.drawImage(this.lightMask, 0, 0, w, h, w, 0, w, h)

      var dayImg = document.getElementById('day')
      this.lightMaskCtx.globalCompositeOperation = 'source-in'
      this.lightMaskCtx.drawImage(
        dayImg,
        0,
        0,
        dayImg.width,
        dayImg.height,
        offset,
        0,
        w,
        h
      )

      this.earth.mapContext.drawImage(
        this.lightMask,
        offset,
        0,
        w,
        h,
        0,
        0,
        w,
        h
      )

      this.earth.updateMap()
    },
    addBackgroundStarfield() {
      function getRandomInt(min, max) {
        min = Math.ceil(min)
        max = Math.floor(max)
        return Math.floor(Math.random() * (max - min)) + min
      }

      var star_count = 1000
      var stars = []

      for (var i = 0; i < star_count; i++) {
        stars.push({
          location: {
            lat: getRandomInt(-50, 50),
            lng: getRandomInt(-180, 180)
          },
          offset: getRandomInt(35, 60),
          opacity: getRandomInt(20, 80) / 100,
          color:
            'rgb(' +
            getRandomInt(180, 255) +
            ',' +
            getRandomInt(180, 255) +
            ',' +
            getRandomInt(180, 255) +
            ')'
        })
      }

      this.earth.addPoints({
        points: stars,
        scale: 0.5 + window.innerWidth / 2000
      })
    },
    chooseChallenge(index) {
      if (this.isChallengeBlocked(this.challenges[index])) {
        console.log(
          'That challenge is currently locked. Choose another challenge.'
        )
        this.$emit('blockedChallengeSelected', index)
        return
      }

      if (this.challenges[index].complete) {
        console.log(
          'That challenge is already complete. Choose another challenge.'
        )
        this.$emit('completedChallengeSelected', index)
        return
      }

      this.selectedChallengeIndex = index
      setTimeout(() => {
        this.selectedChallengeIndex = null
      }, 3000)

      this.$emit('challengeSelected', index)
    },
    isChallengeBlocked(challenge) {
      for (const blockingIndex of challenge.blockedBy) {
        if (!this.challenges[blockingIndex].complete) {
          return true
        }
      }

      let completeCountRequired = challenge.blockedBeforeCompleteCount || 0

      if (completeCountRequired > 0) {
        let currentCompleteCount = this.challenges.filter(
          challenge => challenge.complete
        ).length

        if (currentCompleteCount < completeCountRequired) {
          return true
        }
      }

      return false
    },
    hotspotClicked(hotspotData) {
      console.log(`🎯🎯🎯 Hotspot clicked: ${hotspotData}`)

      const index = this.challenges.findIndex(challenge => {
        return challenge.tag === hotspotData
      })

      if (index != -1) {
        this.chooseChallenge(index)
      } else {
        console.log(`Unknown hotspot clicked: ${hotspotData}`)
      }
    }
  }
}
</script>

<style>
.earthHotspotButton {
  border: 1px solid #f6311c !important;
  padding: 5px 10px !important;
  text-align: center !important;
  border-radius: 20px !important;
  width: 90px !important;
  max-width: 90px !important;
  margin: 0 auto !important;
  background: #f6311c;
}

.earthHotspotLabel {
  font-family: termina, sans-serif;
  font-size: 15px;
  text-align: center;
  line-height: 130%;
  transform: translate(-50%, -50%) !important;
  text-shadow: 0px 0px 14px black !important;
  pointer-events: all;
}

.earthHotspot {
  display: block;
  width: 3em;
  height: 3em;
  cursor: pointer;
  border-radius: 50%;
  pointer-events: all;
  transform: translate(-50%, -50%);
}
.earthHotspot::before {
  content: '';
  position: absolute;
  left: 0.75em;
  top: 0.75em;
  width: 1.5em;
  height: 1.5em;
  opacity: 1;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset,
    rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset,
    rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px,
    rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px,
    rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px !important;
}
.earthHotspot:hover::before {
  opacity: 1;
}

.earthHotspot::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 1.5em;
  height: 1.5em;
  border: 1px #fff solid;
  opacity: 1;
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(1);
  animation: pulse 3s infinite;
}

.earthHotspot + .earthHotspot::after {
  animation-delay: 1.5s;
}

@keyframes pulse {
  0% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(1);
  }
  50%,
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(2.5);
  }
}

#res {
  width: 0;
  height: 0;
  overflow: hidden;
}

#myearth {
  width: 100%;
  height: 100%;
  overflow: hidden;
  opacity: 0;
  transition: opacity 2s ease;
  background: linear-gradient(to right top, #000000, #1f324e, #186dbf);
}
#myearth.earth-ready {
  opacity: 1;
}

#myearth::before {
  content: none;
}

#atmos {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  max-width: 100vh;
  height: 100vh;
  max-height: 100vw;
  transform: translate(-50%, -50%);

  background: radial-gradient(
    ellipse at center,
    rgba(200, 230, 255, 0) 40%,
    rgba(130, 195, 255, 0.2) 49%,
    rgba(33, 63, 255, 0.05) 50.5%,
    rgba(18, 0, 255, 0) 64%
  );
  z-index: 1200;
  pointer-events: none;
  opacity: 0;
}

#info {
  height: 2em;
  margin-top: -3em;
  font-size: 11px;
  text-align: center;
  box-sizing: border-box;
  padding: 0 2em;
}

#controls {
  height: 5em;
  margin-top: -5.1em;
  position: relative;
  z-index: 200;
}

@media (max-width: 719px) {
  #controls {
    margin-top: -2em;
  }
}

#sun-slider {
}
#sun-slider-wrap {
  position: relative;
  margin: 0 auto;
  width: 20em;
  max-width: 80%;
  box-sizing: border-box;
}

#sun-slider-wrap::before {
  content: '';
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNNC4wNjkgMTNoLTQuMDY5di0yaDQuMDY5Yy0uMDQxLjMyOC0uMDY5LjY2MS0uMDY5IDFzLjAyOC42NzIuMDY5IDF6bTMuMDM0LTcuMzEybC0yLjg4MS0yLjg4MS0xLjQxNCAxLjQxNCAyLjg4MSAyLjg4MWMuNDExLS41MjkuODg1LTEuMDAzIDEuNDE0LTEuNDE0em0xMS4yMDkgMS40MTRsMi44ODEtMi44ODEtMS40MTQtMS40MTQtMi44ODEgMi44ODFjLjUyOC40MTEgMS4wMDIuODg2IDEuNDE0IDEuNDE0em0tNi4zMTItMy4xMDJjLjMzOSAwIC42NzIuMDI4IDEgLjA2OXYtNC4wNjloLTJ2NC4wNjljLjMyOC0uMDQxLjY2MS0uMDY5IDEtLjA2OXptMCAxNmMtLjMzOSAwLS42NzItLjAyOC0xLS4wNjl2NC4wNjloMnYtNC4wNjljLS4zMjguMDQxLS42NjEuMDY5LTEgLjA2OXptNy45MzEtOWMuMDQxLjMyOC4wNjkuNjYxLjA2OSAxcy0uMDI4LjY3Mi0uMDY5IDFoNC4wNjl2LTJoLTQuMDY5em0tMy4wMzMgNy4zMTJsMi44OCAyLjg4IDEuNDE1LTEuNDE0LTIuODgtMi44OGMtLjQxMi41MjgtLjg4NiAxLjAwMi0xLjQxNSAxLjQxNHptLTExLjIxLTEuNDE1bC0yLjg4IDIuODggMS40MTQgMS40MTQgMi44OC0yLjg4Yy0uNTI4LS40MTEtMS4wMDMtLjg4NS0xLjQxNC0xLjQxNHptMi4zMTItNC44OTdjMCAyLjIwNiAxLjc5NCA0IDQgNHM0LTEuNzk0IDQtNC0xLjc5NC00LTQtNC00IDEuNzk0LTQgNHptMTAgMGMwIDMuMzE0LTIuNjg2IDYtNiA2cy02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNiA2IDIuNjg2IDYgNnoiLz48L3N2Zz4=)
    center center no-repeat;
  position: absolute;
  top: calc(50% - 1em);
  left: -3em;
  width: 2em;
  height: 2em;
  background-size: 60%;
}

#sun-slider-wrap::after {
  content: '';
  position: absolute;
  top: 50%;
  border-top: 1px white solid;
  left: 2px;
  right: 2px;
}

#sun-slider {
  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  width: 100%; /* Specific width is required for Firefox. */
  background: transparent; /* Otherwise white in Chrome */
  display: block;
  height: 1em;
}

#sun-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
}

#sun-slider:focus {
  outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
}

#sun-slider::-ms-track {
  width: 100%;
  cursor: pointer;

  /* Hides the slider so custom styles can be added */
  background: transparent;
  border-color: transparent;
  color: transparent;
}

#sun-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 24px;
  width: 24px;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  cursor: grab;
}

/* All the same stuff for Firefox */
#sun-slider::-moz-range-thumb {
  height: 24px;
  width: 24px;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  cursor: grab;
}

/* All the same stuff for IE */
#sun-slider::-ms-thumb {
  height: 24px;
  width: 24px;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  cursor: grab;
}
@media only screen and (max-width: 767px) {
  #myearth {
    width: 100%;
    height: calc(100% - 130px);
  }
}
</style>
